import { Typography, Box } from "@material-ui/core";
import React from "react";
import { useStyles } from "./styles";
import { Link } from "react-router-dom";
import ioslogo from "../../../assets/images/ios.webp";
import andriodlog from "../../../assets/images/android.webp";

function Thankyou() {
  const classes = useStyles();
  React.useEffect(() => {
    // localStorage.removeItem("verifiedId")
  }, []);

  return (
    <div className={classes.dflex}>
      <div className={classes.maincontainer}>
        <Typography className={classes.title1}>Thank You</Typography>
        <Typography className={classes.title1}>
          You have Succussfully Registered
        </Typography>
        <Typography className={classes.title1}>
          To login, use:
          {/* < style={{fontSize:'22px',color:"red"}}>Click Here to Login</> */}
        </Typography>

        <Box sx={{ display: "flex", marginTop:"1rem", flexWrap:"wrap" }}>
          <a href={"https://play.google.com/store/apps/details?id=efone.easytel&hl=en"}>
            <img src={andriodlog} height={67} width={200} alt="App Store" />
          </a>
          <a href={"https://apps.apple.com/pk/app/efone/id1356974318"} style={{marginLeft:"0.5rem"}}>
            <img src={ioslogo} height={67} width={200} alt="App Store" />
          </a>
        </Box>
      </div>
    </div>
  );
}

export default Thankyou;
